import Vue from "vue";
import VueRouter from "vue-router";
import Store from "../store/index.js";

Vue.use(VueRouter);
//解决重复点击一个路由报错问题 start
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err);
};
//解决重复点击一个路由报错问题 end
const routerList = [{
		path: "/",
		name: "index",
		component: () => import("@/components/Main.vue"),
		meta: {
			keepAlive: true //导航栏在该页面显示
		}
	},
	{
		path: "/AboutUs",
		name: "aboutUs",
		component: () => import("@/views/AboutUs/AboutUs.vue"),
		meta: {
			keepAlive: true //导航栏在该页面显示
		}
	},
	{
		path: "/News",
		name: "news",
		component: () => import("@/views/News/News.vue"),
		meta: {
			keepAlive: true
		}
	},
	{
		path: "/Bidding",
		name: "bidding",
		component: () => import("@/views/Bidding/Bidding.vue"),
		meta: {
			keepAlive: true
		}
	},
	{
		path: "/UnBidding",
		name: "unbidding",
		component: () => import("@/views/UnBidding/UnBidding.vue"),
		meta: {
			keepAlive: true
		}
	},
	{
		path: "/Supplier",
		name: "supplier",
		component: () => import("@/views/Supplier/Supplier.vue"),
		meta: {
			keepAlive: true
		}
	},
	{
		path: "/PolicyRegular",
		name: "policyregular",
		component: () => import("@/views/PolicyRegular/PolicyRegular.vue"),
		meta: {
			keepAlive: true
		}
	},
	{
		path: "/Server",
		name: "server",
		component: () => import("@/views/Server/Server.vue"),
		meta: {
			keepAlive: true
		}
	},
	{
		path: "/query",
		name: "query",
		component: () => import("@/views/auditProgress/query.vue"),
		meta: {
			keepAlive: false
		}
	},
	{
		path: "/result",
		name: "result",
		component: () => import("@/views/auditProgress/result.vue"),
		meta: {
			keepAlive: false
		}
	},
	{
		path: "/result2904",
		name: "result2904",
		component: () => import("@/views/auditProgress/result2904.vue"),
		meta: {
			keepAlive: false
		}
	},
	{
		path: "/inform",
		name: "inform",
		component: () => import("@/views/auditProgress/inform.vue"),
		meta: {
			keepAlive: false
		}
	},
	{
		path: "/policy",
		name: "policy",
		component: () => import("@/views/register/policy.vue"),
		meta: {
			keepAlive: false
		}
	},
	{
		path: "/Detail",
		name: "detail",
		component: () => import("@/components/common/Detail.vue"),
		meta: {
			keepAlive: true
		}
	},
	{
		path: "/register",
		name: "register",
		component: () => import("@/views/register/index.vue"),
		meta: {
			keepAlive: false
		}
	},
	{
		path: "/password",
		name: "password",
		component: () => import("@/views/register/password.vue"),
		meta: {
			keepAlive: false
		}
	},
	{
		path: "/resetphone",
		name: "resetphone",
		component: () => import("@/views/register/resetphone.vue"),
		meta: {
			keepAlive: false
		}
	},
	{
		path: "/MemberCenter",
		name: "membercenter",
		component: () => import("@/views/MemberCenter/MemberCenter.vue"),
		meta: {
			keepAlive: false,
			isMember: true
		}
	},
	{
		path: "/ChangePassword",
		name: "ChangePassword",
		component: () => import("@/views/MemberCenter/ChangePassword.vue"),
		meta: {
			keepAlive: false,
			isMember: true
		}
	},
	{
		path: "/mbBiddingCenter", //招标中心
		name: "mbBiddingCenter",
		component: () => import("@/views/MemberCenter/mbBiddingCenter.vue"),
		meta: {
			keepAlive: false,
			isMember: true
		}
	},
	{
		path: "/mbQuotation", //在线报价
		name: "mbQuotation",
		component: () => import("@/views/MemberCenter/mbQuotation.vue"),
		meta: {
			keepAlive: false,
			isMember: true
		}
	},
	{
		path: "/mbOlBidding", //在线竞价
		name: "mbOlBidding",
		component: () => import("@/views/MemberCenter/mbOlBidding.vue"),
		meta: {
			keepAlive: false,
			isMember: true
		}
	},
	{
		path: "/mbContract", //采购合同
		name: "mbContract",
		component: () => import("@/views/MemberCenter/mbContract.vue"),
		meta: {
			keepAlive: false,
			isMember: true
		}
	},
	{
		path: "/mbOrder", //采购订单
		name: "mbOrder",
		component: () => import("@/views/MemberCenter/mbOrder.vue"),
		meta: {
			keepAlive: false,
			isMember: true
		}
	},
	{
		path: "/mbCatalog", //供货目录
		name: "mbCatalog",
		component: () => import("@/views/MemberCenter/mbCatalog.vue"),
		meta: {
			keepAlive: false,
			isMember: true
		}
	},
	//企业信息
	// 跳转到二级页面，不包含首页的左tab  ---start
	{
		path: "/Notify",
		name: "notify",
		component: () => import("@/views/MemberCenter/Notify.vue"),
		meta: {
			keepAlive: false,
			isMember: true
		}
	},
	{
		path: "/AuditRecord",
		name: "AuditRecord",
		component: () =>
			import("@/views/MemberCenter/EnterpriseInfo/AuditRecord.vue"),
		meta: {
			keepAlive: false,
			isMember: true
		}
	},
	{
		path: "/ChangeInform",
		name: "ChangeInform",
		component: () =>
			import("@/views/MemberCenter/EnterpriseInfo/ChangeInform.vue"),
		meta: {
			keepAlive: false,
			isMember: true
		}
	},
	{
		path: "/SuccessApply",
		name: "SuccessApply",
		component: () =>
			import("@/views/MemberCenter/EnterpriseInfo/SuccessApply.vue"),
		meta: {
			keepAlive: false,
			isMember: true
		}
	},
	{
		path: "/AccountDataEdit",
		name: "AccountDataEdit",
		component: () =>
			import("@/views/MemberCenter/EnterpriseInfo/AccountDataEdit.vue"),
		meta: {
			keepAlive: false,
			isMember: true
		}
	},
	{
		path: "/ContactsChange",
		name: "ContactsChange",
		component: () =>
			import("@/views/MemberCenter/EnterpriseInfo/ContactsChange.vue"),
		meta: {
			keepAlive: false,
			isMember: true
		}
	},
	{
		path: "/EnterpriseInform",
		name: "EnterpriseInform",
		component: () =>
			import("@/views/MemberCenter/EnterpriseInfo/EnterpriseInform.vue"),
		meta: {
			keepAlive: false,
			isMember: true
		}
	},
	{
		path: "/RegisterForm",
		name: "RegisterForm",
		component: () => import("@/components/common/RegisterForm.vue"),
		meta: {
			keepAlive: false
		}
	},
	{
		path: "/personal",
		name: "personal",
		component: () => import("@/views/register/personal.vue"),
		meta: {
			keepAlive: false
		}
	},
	{
		path: "/UploadTenderDoc",
		name: "UploadTenderDoc",
		component: () => import("@/views/InvitationManage/UploadTenderDoc.vue"),
		meta: {
			keepAlive: false,
			isMember: true
		}
	},
	{
		path: "/TenderDocList",
		name: "TenderDocList",
		component: () => import("@/views/InvitationManage/TenderDocList.vue"),
		meta: {
			keepAlive: false,
			isMember: true
		}
	},
	{
		path: "/InvitationList",
		name: "InvitationList",
		component: () => import("@/views/InvitationManage/InvitationList.vue"),
		meta: {
			keepAlive: false,
			isMember: true
		}
	},
	{
		path: "/BidResultList",
		name: "BidResultList",
		component: () => import("@/views/InvitationManage/BidResultList.vue"),
		meta: {
			keepAlive: false,
			isMember: true
		}
	},
	{
		path: "/ClarifyList",
		name: "ClarifyList",
		component: () => import("@/views/InvitationManage/ClarifyList.vue"),
		meta: {
			keepAlive: false,
			isMember: true
		}
	},
	{
		path: "/InvitationReciept",
		name: "InvitationReciept",
		component: () => import("@/views/InvitationManage/InvitationReciept.vue"),
		meta: {
			keepAlive: false,
			isMember: true
		}
	},
	{
		path: "/BidResulDetail",
		name: "BidResulDetail",
		component: () => import("@/views/InvitationManage/BidResulDetail.vue"),
		meta: {
			keepAlive: false,
			isMember: true
		}
	},
	{
		path: "/ClarifyReciept",
		name: "ClarifyReciept",
		component: () => import("@/views/InvitationManage/ClarifyReciept.vue"),
		meta: {
			keepAlive: false,
			isMember: true
		}
	},
	{
		path: "/tradeQuery",
		name: "tradeQuery",
		component: () => import("@/views/CAManage/tradeQuery.vue"),
		meta: {
			keepAlive: false,
			isMember: true
		}
	},
	{
		path: "/updateLogin",
		name: "updateLogin",
		component: () => import("@/views/CAManage/updateLogin.vue"),
		meta: {
			keepAlive: false,
			isMember: true
		}
	},
	{
		path: "/unlockRequest",
		name: "unlockRequest",
		component: () => import("@/views/CAManage/unlockRequest.vue"),
		meta: {
			keepAlive: false,
			isMember: true
		}
	},
	{
		path: "/modifyLogin",
		name: "modifyLogin",
		component: () => import("@/views/CAManage/modifyLogin.vue"),
		meta: {
			keepAlive: false,
			isMember: true
		}
	},
	{
		path: "/certReplace",
		name: "certReplace",
		component: () => import("@/views/CAManage/certReplace.vue"),
		meta: {
			keepAlive: false,
			isMember: true
		}
	},
	{
		path: "/ApplyNewCert",
		name: "ApplyNewCert",
		component: () => import("@/views/CAManage/ApplyNewCert.vue"),
		meta: {
			keepAlive: false,
			isMember: true
		}
	},
	{
		path: "/CABinding",
		name: "CABinding",
		component: () => import("@/views/CAManage/CABinding.vue"),
		meta: {
			keepAlive: false,
			isMember: true
		}
	},
	{
		path: "/CertDeactive",
		name: "CertDeactive",
		component: () => import("@/views/CAManage/CertDeactive.vue"),
		meta: {
			keepAlive: false,
			isMember: true
		}
	},
	{
		path: "/QuestionList",
		name: "QuestionList",
		component: () => import("@/views/QuestionManage/QuestionList.vue"),
		meta: {
			keepAlive: false,
			isMember: true
		}
	},
	{
		path: "/ScheduleQuery",
		name: "ScheduleQuery",
		component: () => import("@/views/CAManage/ScheduleQuery.vue"),
		meta: {
			keepAlive: false,
			isMember: true
		}
	},
	{
		path: "/InvitationList",
		name: "InvitationList",
		component: () => import("@/views/InvitationManage/InvitationList.vue"),
		meta: {
			keepAlive: false,
			isMember: true
		}
	},
	{
		path: "/EvaluationClarifyList",
		name: "EvaluationClarifyList",
		component: () => import("@/views/EvaluationClarify/EvaluationClarifyList.vue"),
		meta: {
			keepAlive: false,
			isMember: true
		}
	},
	{
		path: "/NegotiationQuotation",
		name: "NegotiationQuotation",
		component: () => import("@/views/Negotiation/NegotiationQuotation.vue"),
		meta: {
			keepAlive: false,
			isMember: true
		}
	},
	{
		path: "/MessageList",
		name: "MessageList",
		component: () => import("@/views/Message/MessageList.vue"),
		meta: {
			keepAlive: false,
			isMember: true
		}
	},
	{
		path: "/MessageDetail",
		name: "MessageDetail",
		component: () => import("@/views/Message/MessageDetail.vue"),
		meta: {
			keepAlive: false,
			isMember: true
		}
	},
	{
		path: "/InvitationRecieptDetail",
		name: "InvitationRecieptDetail",
		component: () => import("@/views/InvitationManage/InvitationRecieptDetail.vue"),
		meta: {
			keepAlive: false,
			isMember: true
		}
	},
	{
		path: "/OnlineBiddingNotice",
		name: "OnlineBiddingNotice",
		component: () => import("@/views/OnlineBidding/OnlineBiddingNotice.vue"),
		meta: {
			keepAlive: false,
			isMember: true
		}
	},
	{
		path: "/OnlineBiddingRoom",
		name: "OnlineBiddingRoom",
		component: () => import("@/views/OnlineBidding/OnlineBiddingRoom.vue"),
		meta: {
			keepAlive: false,
			isMember: true
		}
	},
	{
		path: "/EditOnlineBidding",
		name: "EditOnlineBidding",
		component: () => import("@/views/OnlineBidding/EditOnlineBidding.vue"),
		meta: {
			keepAlive: false,
			isMember: true
		}
	},
	{
		path: "/CASeal",
		name: "CASeal",
		component: () => import("@/views/OnlineBidding/CASeal.vue"),
		meta: {
			keepAlive: false,
			isMember: true
		}
	},
	{
		path: "/ReadPDF",
		name: "ReadPDF",
		component: () => import("@/views/Common/ReadPDF.vue"),
		meta: {
			keepAlive: false,
			isMember: true
		}
	},
	{
		path: "/InQuiryDetailList",
		name: "InQuiryDetailList",
		component: () => import("@/views/InQuiryPrice/DetailList.vue"),
		meta: {
			keepAlive: false,
			isMember: true
		}
	},
	{
		path: "/CommittingOfferList",
		name: "CommittingOfferList",
		component: () => import("@/views/InQuiryPrice/CommittingOfferList.vue"),
		meta: {
			keepAlive: false,
			isMember: true
		}
	},
	{
		path: "/CommittedOfferList",
		name: "CommittedOfferList",
		component: () => import("@/views/InQuiryPrice/CommittedOfferList.vue"),
		meta: {
			keepAlive: false,
			isMember: true
		}
	},
	{
		path: "/EditOffers",
		name: "EditOffers",
		component: () => import("@/views/InQuiryPrice/EditOffers.vue"),
		meta: {
			keepAlive: false,
			isMember: true
		}
	},
	{
		path: "/OnlineBiddingResultList",
		name: "OnlineBiddingResultList",
		component: () => import("@/views/OnlineBidding/OnlineBiddingResultList.vue"),
		meta: {
			keepAlive: false,
			isMember: true
		}
	},
	{
		path: "/OnlineBiddingDetail",
		name: "OnlineBiddingDetail",
		component: () => import("@/views/OnlineBidding/OnlineBiddingDetail.vue"),
		meta: {
			keepAlive: false,
			isMember: true
		}
	},
	{
		path: "/ContractDetail",
		name: "ContractDetail",
		component: () => import("@/views/Contract/ContractDetail.vue"),
		meta: {
			keepAlive: false,
			isMember: true
		}
	},
	{
		path: "/ContractList",
		name: "ContractList",
		component: () => import("@/views/Contract/ContractList.vue"),
		meta: {
			keepAlive: false,
			isMember: true
		}
	},
	{
		path: "/ArrivalFollowList",
		name: "ArrivalFollowList",
		component: () => import("@/views/Contract/ArrivalFollowList.vue"),
		meta: {
			keepAlive: false,
			isMember: true
		}
	},
	{
		path: "/EditContract",
		name: "EditContract",
		component: () => import("@/views/Contract/EditContract.vue"),
		meta: {
			keepAlive: false,
			isMember: true
		}
	},
	{
		path: "/EditInvoice",
		name: "EditInvoice",
		component: () => import("@/views/Contract/EditInvoice.vue"),
		meta: {
			keepAlive: false,
			isMember: true
		}
	},
	{
		path: "/UploadContractFile",
		name: "UploadContractFile",
		component: () => import("@/views/Contract/UploadContractFile.vue"),
		meta: {
			keepAlive: false,
			isMember: true
		}
	},
	{
		path: "/AuditProgress",
		name: "AuditProgress",
		component: () => import("@/views/Common/AuditProgress.vue"),
		meta: {
			keepAlive: false,
			isMember: true
		}
	},
	{
		path: "/EvaluationClarifyCASeal",
		name: "EvaluationClarifyCASeal",
		component: () => import("@/views/EvaluationClarify/CASeal.vue"),
		meta: {
			keepAlive: false,
			isMember: true
		}
	},
	{
		path: "/ComfirmOrder",
		name: "ComfirmOrder",
		component: () => import("@/views/Order/ComfirmOrder.vue"),
		meta: {
			keepAlive: false,
			isMember: true
		}
	},
	{
		path: "/OrderCASeal",
		name: "OrderCASeal",
		component: () => import("@/views/Order/OrderCASeal.vue"),
		meta: {
			keepAlive: false,
			isMember: true
		}
	},
	{
		path: "/OrderInvoice",
		name: "OrderInvoice",
		component: () => import("@/views/Order/OrderInvoice.vue"),
		meta: {
			keepAlive: false,
			isMember: true
		}
	},
	{
		path: "/Reconciliation",
		name: "Reconciliation",
		component: () => import("@/views/Order/Reconciliation.vue"),
		meta: {
			keepAlive: false,
			isMember: true
		}
	},
	{
		path: "/OrderDetail",
		name: "OrderDetail",
		component: () => import("@/views/Order/OrderDetail.vue"),
		meta: {
			keepAlive: false,
			isMember: true
		}
	}, {
		path: "/ReconciliationCASeal",
		name: "ReconciliationCASeal",
		component: () => import("@/views/Order/ReconciliationCASeal.vue"),
		meta: {
			keepAlive: false,
			isMember: true
		}
	},
	{
		path: "/SupplierOrderList",
		name: "SupplierOrderList",
		component: () => import("@/views/CAManage/SupplierOrderList.vue"),
		meta: {
			keepAlive: false,
			isMember: true
		}
	},
	{
		path: "/Reply",
		name: "Reply",
		component: () => import("@/views/EvaluationClarify/Reply.vue"),
		meta: {
			keepAlive: false,
			isMember: true
		}
	},
	{
		path: "/ArrivalConfirm",
		name: "ArrivalConfirm",
		component: () => import("@/views/Contract/ArrivalConfirm.vue"),
		meta: {
			keepAlive: false,
			isMember: true
		}
	},
	{
		path: "/InvoiceUpload",
		name: "InvoiceUpload",
		component: () => import("@/views/Contract/InvoiceUpload.vue"),
		meta: {
			keepAlive: false,
			isMember: true
		}
	},
	{
		path: "/unbanInform",
		name: "unbanInform",
		component: () => import("@/views/register/unbanInform.vue"),
		meta: {
			keepAlive: false
		}
	},
	{
		path: "/unbanInform4Member",
		name: "unbanInform",
		component: () => import("@/views/register/unbanInform.vue"),
		meta: {
			keepAlive: false,
			isMember: true
		}
	},
	{
		path: "/otherDailyEvaluationResultEdit4Mobile",
		name: "otherDailyEvaluationResultEdit4Mobile",
		component: () => import("@/views/Evaluation/OtherDailyEvaluationResultEdit4Mobile.vue"),
		meta: {
			keepAlive: false,
			isMember: false,
			isMobilePage: true,
		}
	},
	{
		path: "/RetentionPaymentEdit",
		name: "RetentionPaymentEdit",
		component: () => import("@/views/Contract/RetentionPaymentEdit.vue"),
		meta: {
			keepAlive: false,
			isMember: true
		}
	},
	// 跳转到二级页面，不包含首页的左tab  ---end
];
const list = [
	"/",
	"/AuditProgress",
	"/ContractDetail",
	"/ContractList",
	"/ArrivalFollowList",
	"/EditContract",
	"/EditInvoice",
	"/UploadContractFile",
	"/AboutUs",
	"/News",
	"/Bidding",
	"/UnBidding",
	"/Supplier",
	"/PolicyRegular",
	"/Server",
	"/query",
	"/result",
	"/result2904",
	"/inform",
	"/policy",
	"/Detail",
	"/register",
	"/password",
	"/resetphone",
	"/MemberCenter",
	"/ChangePassword",
	"/mbBiddingCenter",
	"/mbQuotation",
	"/mbOlBidding",
	"/mbContract",
	"/mbOrder",
	"/mbCatalog",
	"/Notify",
	"/AuditProgress",
	"/AuditRecord",
	"/ChangeInform",
	"/AccountDataEdit",
	"/ContactsChange",
	"/EnterpriseInform",
	"/RegisterForm",
	"/personal",
	"/SuccessApply",
	"/UploadTenderDoc",
	"/TenderDocList",
	"/InvitationList",
	"/ClarifyList",
	"/BidResultList",
	"/InvitationReciept",
	"/BidResulDetail",
	"/ClarifyReciept",
	"/ApplyNewCert",
	"/tradeQuery",
	"/updateLogin",
	"/unlockRequest",
	"/modifyLogin",
	"/certReplace",
	"/CABinding",
	"/CertDeactive",
	"/ScheduleQuery",
	"/QuestionList",
	"/EvaluationClarifyList",
	"/NegotiationQuotation",
	"/MessageList",
	"/MessageDetail",
	"/InvitationRecieptDetail",
	"/OnlineBiddingNotice",
	"/OnlineBiddingRoom",
	"/EditOnlineBidding",
	"/CASeal",
	"/ReadPDF",
	"/InQuiryDetailList",
	"/CommittingOfferList",
	"/CommittedOfferList",
	"/EditOffers",
	"/OnlineBiddingResultList",
	"/OnlineBiddingDetail",
	"/EvaluationClarifyCASeal",
	"/ComfirmOrder",
	"/OrderCASeal",
	"/OrderInvoice",
	"/Reconciliation",
	"/OrderDetail",
	"/ReconciliationCASeal",
	"/SupplierOrderList",
	"/Reply",
	"/ArrivalConfirm",
	"/InvoiceUpload",
	"/unbanInform",
	"/unbanInform4Member",
	"/otherDailyEvaluationResultEdit4Mobile",
	"/RetentionPaymentEdit"
]; //后台返回数据
let routes = [];
list.forEach(path => {
	let router = routerList.filter(item => {
		return item.path == path;
	});
	routes.push(...router);
});

const router = new VueRouter({
	routes
});
export default router;